import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`GHG_EnergiaEletricaCompra/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td>{rs.tipoGeracaoEnergia}</td>
                    <td>{rs.combustivel}</td>
                    <td>{rs.tipoGeracaoEnergia}</td>
                    <td>{rs.possuiFatorEmissao}</td>
                    <td>{rs.eficienciaPlantaGeradora}</td>
                    <td>{rs.eletricidadeTotalComprada}</td>
                    <td>{rs.emissoesCO2}</td>
                    <td>{rs.emissoesN2O}</td>
                    <td>{rs.emissoesCO2E}</td>
                    <td>{rs.emissoesCO2Bio}</td>
                    
                    
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Descricao Fonte
                                </center>

                            </th>
                        
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Tipo Geracao Energia
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Combustivel
                                </center>

                            </th>


                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Possui Fator Emissao
                                </center>

                            </th>
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Eficiencia Planta Geradora
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Eletricidade Total Comprada
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup>
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes N<sup>2</sup>O
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup>E
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup> Bio
                                </center>

                            </th>
                            
                            

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel